import gql from 'graphql-tag';

const GET_POLICY_TEMPLATES = gql`
  query($classId: ID!) {
    getPolicyTemplates(classId: $classId) {
      policyType
      policyTemplates {
        policyTemplateId
        createdTime
        updatedTime
        name
        assetClass {
          classId
        }
        isDefault
        alertConfig
      }
    }
  }
`;

const IMPORT_POLICIES_FROM_TEMPLATE = gql`
  mutation(
    $policySetId: ID!
    $policyTemplateIds: [ID!]!
    $clientId: ID
    $siteId: ID
    $assetId: ID
  ) {
    importPoliciesFromTemplates(
      policySetId: $policySetId
      policyTemplateIds: $policyTemplateIds
      clientId: $clientId
      siteId: $siteId
      assetId: $assetId
    ) {
      policySetId
    }
  }
`;

export { GET_POLICY_TEMPLATES, IMPORT_POLICIES_FROM_TEMPLATE };
